// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] + "." + {"112":"560626b1","420":"6141ba46","539":"5b2272f4","644":"eed096d1","857":"235c64a5","884":"d0c3be1b"}[chunkId] + ".css";
};